var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForfait(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.19 19.83",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d69fa;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Give_Money",
    "data-name": "Give Money"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.15,15.92h-5.22c-1.07-.01-1.93-.89-1.92-1.96.01-1.05.86-1.9,1.92-1.92h5.21c.07,0,.95-.05,2.05-.53l.08-.03c.86-.38,2.11-.88,3.02-.89,1.05,0,1.96.22,2.72.66.22.13.3.41.18.63s-.41.3-.63.18c0,0-.01,0-.02-.01-.6-.36-1.36-.54-2.23-.53-.54,0-1.44.28-2.65.81l-.08.04c-1.3.57-2.35.6-2.39.6h-5.23c-.56,0-1,.47-.99,1.03,0,.54.45.98.99.99h5.22c.26,0,.47.21.47.47s-.21.47-.47.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.13,19.83c-.36,0-.72-.03-1.08-.09-.71-.12-1.7-.45-2.08-.58l-.06-.02c-1.94-.65-4.01-1.93-6.14-3.8C1.2,13.96.2,12.78.16,12.73c-.05-.06-.09-.14-.1-.22-.16-.98.01-1.72.52-2.18.8-.74,2.08-.44,2.13-.43.06.01.11.04.16.08l4.87,3.51c.21.15.26.44.1.65-.15.21-.44.26-.65.1l-4.78-3.45c-.29-.05-.88-.08-1.2.22-.29.28-.3.79-.25,1.22.76.86,1.58,1.67,2.45,2.43,1.4,1.22,3.54,2.84,5.81,3.6l.06.02c.35.12,1.29.44,1.93.54.69.11,1.78.15,3.06-.29l2.96-1.3s.02,0,.03-.01c.15-.06,1.52-.56,2.19-.66.75-.11,1.38-.13,1.87-.08v-4.85c0-.26.21-.47.47-.47s.47.21.47.47v5.43c0,.26-.21.47-.46.47-.06,0-.11-.01-.17-.03-.37-.14-1.09-.15-2.03,0-.48.07-1.58.45-1.98.6l-2.96,1.3s-.02,0-.04.01c-.79.28-1.62.42-2.45.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.72,18.96h-1.97c-.26,0-.47-.21-.47-.47v-8.52c0-.26.21-.47.47-.47h1.97c.26,0,.47.21.47.47v8.52c0,.26-.21.47-.47.47Zm-1.5-.93h1.04v-7.59h-1.04v7.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Euro"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.09,11.27c-3.1,0-5.64-2.54-5.64-5.64S8.99,0,12.09,0s5.64,2.54,5.64,5.64-2.54,5.64-5.64,5.64Zm0-10.33c-2.58,0-4.7,2.11-4.7,4.7s2.11,4.7,4.7,4.7,4.7-2.11,4.7-4.7S14.68.94,12.09.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.56,8.45c-1.55,0-2.82-1.27-2.82-2.82s1.27-2.82,2.82-2.82c.61,0,1.22.19,1.69.56.19.14.23.47.09.66s-.47.23-.66.09c-.33-.23-.7-.38-1.13-.38-1.03,0-1.88.85-1.88,1.88s.85,1.88,1.88,1.88c.42,0,.8-.14,1.13-.38.19-.14.52-.09.66.09s.09.52-.09.66c-.47.38-1.08.56-1.69.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.56,6.11h-3.29c-.28,0-.47-.19-.47-.47s.19-.47.47-.47h3.29c.28,0,.47.19.47.47s-.19.47-.47.47Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForfait);
export default __webpack_public_path__ + "static/media/forfait.eea382207e64255d05c97c43be158b01.svg";
export { ForwardRef as ReactComponent };